import React, { useEffect, useState } from "react";
import { XCircleIcon } from "@heroicons/react/solid";
import CheckMarkSvg from "../../Icons/CheckMarkSvg";
import { getServicesAvailable } from "services";

export interface AvailableServicesProps {
  property: any;
}
export default function AvailableServices(props: AvailableServicesProps) {
  const [servicesAvailable, setServicesAvailable] = useState([]);

  const getServices = () => {
    const data: any = getServicesAvailable();
    setServicesAvailable(data);
  };

  useEffect(() => {
    getServices();
  }, []);

  return (
    <div className="bg-white py-8 px-4 sm:px-6 lg:px-8">
      <div className="relative max-w-lg mx-auto lg:max-w-7xl">
        <div className="text-left">
          <h2 className="text-xl tracking-tight font-semibold text-gray-900 sm:tracking-tight">
            Services available for property
          </h2>
          <p className="mt-2 text-base text-gray-500 sm:mt-4"></p>
        </div>
        <div className="py-6 lg:grid lg:grid-cols-3 lg:gap-6 lg:items-start">
          {servicesAvailable?.map((item: any, index: any) => {
            return (
              <div className="flex justify-between items-center" key={index}>
                <div className="flex items-center">
                  {item.value ? (
                    <CheckMarkSvg />
                  ) : (
                    <XCircleIcon
                      height={18}
                      width={18}
                      className="text-red-300"
                    />
                  )}
                  <div className="ml-2 mt-2 lg:mt-0">
                    <div className="text-base lg:text-sm font-medium">
                      {item.label}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
